/**
 * Prompt checks applied before any LLM call (ported from the server's former
 * input-validation module).
 */

const MAX_PROMPT_LENGTH = 2000;

// NOTE: no `g` flag — `.test()` on a global regex advances `lastIndex` and
// makes matching stateful across calls.
const DANGEROUS_PATTERNS = [
  /ignore\s+(previous|all|above)\s+(instructions|prompts?|commands?)/i,
  /disregard\s+(previous|all|above)/i,
  /forget\s+(everything|all|previous)/i,
  /new\s+(instruction|task|prompt):/i,
  /system\s*(prompt|message|role):/i
];

/**
 * Validate and normalize a prompt. Throws `Invalid input: …` on failure.
 */
export function validatePrompt(prompt) {
  const sanitized = (typeof prompt === 'string' ? prompt : String(prompt || ''))
    .trim()
    .replace(/\s+/g, ' ');

  let problem = null;
  if (sanitized.length === 0) {
    problem = 'Prompt cannot be empty';
  } else if (sanitized.length > MAX_PROMPT_LENGTH) {
    problem = `Prompt too long (max ${MAX_PROMPT_LENGTH} characters)`;
  } else if (DANGEROUS_PATTERNS.some((pattern) => pattern.test(sanitized))) {
    problem = 'Prompt contains suspicious content that may be attempting injection';
  }

  if (problem) {
    throw new Error(`Invalid input: ${problem}`);
  }

  return sanitized;
}
